import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import cx from 'classnames'
import { File } from 'containers/misc'
import {
  CONFIGURATION_TYPES,
  ROLES,
  ORGANIZATION_HIERARCHY
} from 'constants/enums'
import { getActiveRole } from 'utils/token'
import styles from './config-key.styl'

export default class ConfigKey extends Component {
  static propTypes = {
    config: PropTypes.object,
    options: PropTypes.object,
    standalone: PropTypes.bool,
    isSameLevel: PropTypes.bool,
    hideDescription: PropTypes.bool,
    compact: PropTypes.bool,
    editCustomizationEnabled: PropTypes.bool,
    activeOrganization: PropTypes.object,
    onConfigEdit: PropTypes.func.isRequired
  }

  static defaultProps = {
    standalone: true,
    compact: false,
    hideDescription: false,
    options: {}
  }

  handleCheckRights = config => {
    const { options, activeOrganization } = this.props

    let canSet = false

    let canSee = false

    const settable = get(config, 'configurationKey.settableAtSameLevel')

    switch (options.isTypeId) {
      case ORGANIZATION_HIERARCHY.AU.id:
        canSet = get(config, 'configurationKey.settableAtAU')
        canSee = get(config, 'configurationKey.visibleInUiAtAU')
        break
      case ORGANIZATION_HIERARCHY.IAC.id:
        canSet = get(config, 'configurationKey.settableAtIAC')
        canSee = get(config, 'configurationKey.visibleInUiAtIAC')
        break
      case ORGANIZATION_HIERARCHY.IAF.id:
        canSet = get(config, 'configurationKey.settableAtIF')
        canSee = get(config, 'configurationKey.visibleInUiAtIF')
        break
      case ORGANIZATION_HIERARCHY.NAO.id:
        canSet = get(config, 'configurationKey.settableAtNAO')
        canSee = get(config, 'configurationKey.visibleInUiAtNAO')
        break
      case ORGANIZATION_HIERARCHY.OA.id:
        canSet = get(config, 'configurationKey.settableAtOA')
        canSee = get(config, 'configurationKey.visibleInUiAtOA')
        break
      case ORGANIZATION_HIERARCHY.SOA.id:
        canSet = get(config, 'configurationKey.settableAtOA')
        canSee = get(config, 'configurationKey.visibleInUiAtOA')
        break
      case ORGANIZATION_HIERARCHY.IC.id:
        canSet = get(config, 'configurationKey.settableAtIC')
        canSee = get(config, 'configurationKey.visibleInUiAtIC')
        break
      case ORGANIZATION_HIERARCHY.RO.id:
        if (getActiveRole(activeOrganization) === ROLES.IF_STAFF_SUPER.u) {
          canSet = get(config, 'configurationKey.settableAtIF')
          canSee = get(config, 'configurationKey.visibleInUiAtIF')
        } else {
          canSet = get(config, 'configurationKey.settableAtRO')
          canSee = get(config, 'configurationKey.visibleInUiAtRO')
        }
        break
      case ROLES.IF_REGION.u:
        canSet = get(config, 'configurationKey.settableAtRO')
        canSee = get(config, 'configurationKey.visibleInUiAtRO')
        break
      default:
    }

    return {
      canSet: canSet && this.props.editCustomizationEnabled,
      canSee,
      settable
    }
  }

  render() {
    const {
      config,
      standalone,
      isSameLevel,
      compact,
      hideDescription
    } = this.props

    let value = null

    let disableForType = false

    const permissions = this.handleCheckRights(config)

    let disabled = !permissions.canSet

    if (isSameLevel) {
      disabled = !permissions.settable || !permissions.canSet
    }

    if (!permissions.canSee && !standalone) {
      return null
    }

    switch (get(config, 'configurationKey.valueType')) {
      case CONFIGURATION_TYPES.boolean.id:
        value = get(config, 'booleanValue') ? 'true' : 'false'
        break
      case CONFIGURATION_TYPES.integer.id:
        value = get(config, 'intValue')
        break
      case CONFIGURATION_TYPES.textTranslated.id:
        value = get(config, 'translatedText')
        // disableForType = true
        break
      case CONFIGURATION_TYPES.text.id:
        value = get(config, 'textValue')
        break
      case CONFIGURATION_TYPES.decimal.id:
        value = get(config, 'decimalValue')
        disableForType = false
        break
      case CONFIGURATION_TYPES.codeListValueTranslated.id:
        value = get(config, 'codeListValueTranslated')
        break
      case CONFIGURATION_TYPES.blob.id:
        value = (
          <File src={get(config, 'fileUrl')} title={'FILE'} withAuthCode />
        )
        break
      default:
        value = null
    }

   return (
      <div
        className={cx(styles.config, {
          [styles.compact]: compact,
          [styles.noDescription]: hideDescription
        })}
      >
        {!hideDescription &&
          <span className={`${styles.blockDescription} ${styles.key}`}>
            {get(config, 'configurationKey.translatedDescription')}
          </span>}
        <span className={`${styles.block} ${styles.value}`}>{value}</span>
        {!disabled &&
          (!disableForType &&
            <span
              role="button"
              className={`ico ico--edit ${styles.ico}`}
              onClick={() => this.props.onConfigEdit(config)}
            />)}
      </div>
    )
  }
}
